import { createFileRoute } from '@tanstack/react-router';
import { requireRole } from '@/lib/routeGuards';
import { AssistantTestBench } from '@/components/admin/assistant-telemetry';

// Platform-admin only; the API is the durable gate (403 for anyone else).
export const Route = createFileRoute('/admin/assistant-test/')({
  beforeLoad: ({ context }) => {
    requireRole(context, ['admin'], '/admin/assistant-test');
  },
  component: AssistantTestBench,
});
